<template>
    <section class="relative overflow-hidden border-b border-green-600 bg-gray-200 dark:bg-gray-800">
        <PagesPageHeader
            :breadcrumbs="breadcrumbs"
            title="Agarwood Opportunities"
            description="Agarwood or Gaharu as it is known in many Asian countries is a resinous heartwood that occurs in trees belonging to the genus Aquilaria."
            icon="i-bi-graph-up-arrow"
            iconColor="green"
            color="blue"
            :image="true"
            src="/assets/images/sliders/slider-03.webp" />
    </section>

    <PagesOpportunitiesMain />
    <PagesCalloutsPlantationOwnership />
</template>

<script setup>
    definePageMeta({
        layout: 'default'
    })

    const config = useRuntimeConfig()
    const router = useRouter()

    useHead({
        title: `${config.public.company.name} | Agarwood Opportunities`,
        meta: [
            {
                name: 'description',
                content:
                    'Agarwood or Gaharu as it is known in many Asian countries is a resinous heartwood that occurs in trees belonging to the genus Aquilaria.'
            },
            { name: 'robots', content: 'index, follow' }
        ],
        link: [{ rel: 'canonical', href: `${config.public.base.url + router.currentRoute.value.path}` }]
    })

    const breadcrumbs = [{ label: 'Home', to: '/' }, { label: 'Opportunities' }]
</script>
